
function NotFoundComponent() {
  return (
    <div>
      <figure class="image img-not-found">
        <img src={require("./../assets/404-error.jpg" )}/>
      </figure>
    </div>
  );
}

export default NotFoundComponent;